module.exports = __webpack_public_path__ + "img/circle-arrow-right.55bca280.png";